/* RUSTFIELD BUNDLE/UPSELL — Northryn UX port; Rustfield products via metafields */
;(() => {
function bundleLog(type, event, ...content) {
  const KEY = "123123";
  const prefix = event ? `${KEY} ${event}` : KEY;
  if (type === "warning") {
    console.warn(prefix, ...content);
  } else if (type === "error") {
    console.error(prefix, ...content);
  } else {
    console.log(prefix, ...content);
  }
}

class ProductsBundleCustom extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.bundleKey = this.dataset.bundleKey || "bundle";
    this.contentContainer = this.querySelector(".bundle-test__content");
    this.footerContainer = this.querySelector(".bundle-test__footer");
    this.addToCartBtn = this.querySelector(".bundle-add-to-cart");
    this.totalContainer = this.querySelector(".bundle-test__total");
    this.sharedTooltipEl = null;
    this.activeTooltipTrigger = null;
    this._onTooltipDocumentClick = null;
    this._onTooltipViewportChange = null;
    this.sliderAutoplayTimers = [];
  }

  disconnectedCallback() {
    this._nrGeneration = (this._nrGeneration || 0) + 1;
    if (this.addToCartBtn && this._nrAddClick) this.addToCartBtn.removeEventListener('click', this._nrAddClick);
    this._nrAbort?.abort();
    clearInterval(this._nrSyncTimer);
    clearInterval(this._nrCartTimer);
    (this._nrSliderResizeObservers || []).forEach(observer => observer.disconnect());
    this._nrSliderResizeObservers = [];
    if (this.variantPopup) { this.variantPopup.remove(); this.variantPopup = null; }
    if (this.sharedTooltipEl) { this.sharedTooltipEl.remove(); this.sharedTooltipEl = null; }
    if (this._onTooltipDocumentClick) {
      document.removeEventListener('click', this._onTooltipDocumentClick);
      for (const name of ['pointerdown','touchstart','click','focusin']) {
        document.removeEventListener(name, this._onTooltipDocumentClick, true);
      }
    }
    if (this._onTooltipViewportChange) {
      window.removeEventListener('resize', this._onTooltipViewportChange);
      window.removeEventListener('scroll', this._onTooltipViewportChange, true);
    }
    this._onTooltipDocumentClick = null;
    this._onTooltipViewportChange = null;
    if (this._nrBundleTitleMedia && this._nrBundleTitleChange) {
      if (this._nrBundleTitleMedia.removeEventListener) {
        this._nrBundleTitleMedia.removeEventListener('change', this._nrBundleTitleChange);
      } else {
        this._nrBundleTitleMedia.removeListener(this._nrBundleTitleChange);
      }
      this._nrBundleTitleMedia = null;
      this._nrBundleTitleChange = null;
    }
    (this.sliderAutoplayTimers || []).forEach((timerId) => window.clearInterval(timerId));
    this.sliderAutoplayTimers = [];
  }
  async connectedCallback() {
    // Refresh references on reconnection and when updating an older theme controller.
    this.sectionId = this.dataset.sectionId;
    this.bundleKey = this.dataset.bundleKey || 'bundle';
    this.contentContainer = this.querySelector('.bundle-test__content');
    this.footerContainer = this.querySelector('.bundle-test__footer');
    this.addToCartBtn = this.querySelector('.bundle-add-to-cart');
    this.totalContainer = this.querySelector('.bundle-test__total');
    this.sliderAutoplayTimers = this.sliderAutoplayTimers || [];
    this.dataset.bundleRevision = 'bundle-layout-10';
    const generation = this._nrGeneration = (this._nrGeneration || 0) + 1;
    this._nrAbort?.abort();
    this._nrAbort = new AbortController();
    this._nrCart = null;
    if (this.bundleKey === 'upselling') {
      this.bundleCollections = window.upsellingBundleCollectionsData || [];
      this.bundleInfo = window.upsellingBundleInfoData || {};
    } else {
      this.bundleCollections = window.bundleCollectionsData || [];
      this.bundleInfo = window.bundleInfoData || {};
    }
    if (!this.contentContainer || !this.footerContainer) return;
    try {
      await this.nrPrepareProducts();
      if (!this.isConnected || generation !== this._nrGeneration) return;
      this.collectionStates = {};
      this.initVariantPopup();
      this.initSharedTooltip();
      this.renderBundleItems();
      this.nrStartSync();
      await this.nrRefreshCart();
    } catch (error) {
      this.nrSetNotice('Unable to load your bundle: ' + error.message, true);
    }
  }

  nrEscape(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  nrMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: this._nrCart?.currency || this.dataset.currency || 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  nrRoot() { return window.Shopify?.routes?.root || '/'; }

  async nrReadJSON(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store', ...options, signal:controller.signal});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || `Request failed (${response.status}).`);
      return data;
    } finally { clearTimeout(timeout); }
  }

  async nrPrepareProducts() {
    const config = this.querySelector('[data-nr-current-product]');
    if (config) {
      this._nrMainProduct = JSON.parse(config.textContent);
      this._nrMainProduct.url = this._nrMainProduct.url || this.dataset.productUrl;
    }
    if (!this._nrMainProduct && this.nrMainEnabled()) {
      const productUrl = this.dataset.productUrl || window.location?.pathname || '';
      const handle = productUrl.split('/products/')[1]?.split(/[?#/]/)[0];
      if (handle) {
        this._nrMainProduct = await this.nrReadJSON(this.nrRoot() + 'products/' + encodeURIComponent(handle) + '.js');
        this._nrMainProduct.url = this.dataset.productUrl || productUrl;
      }
    }
    this._nrMainIncluded = !!this._nrMainProduct;
    const collections = JSON.parse(JSON.stringify(this.bundleCollections || []));
    window.nrBundleProductCache = window.nrBundleProductCache || new Map();
    const jobs = collections.flatMap(col => (col.products || []).map(product => ({col, product})));
    const enrich = async ({product}) => {
      if (this.shouldOpenProductInNewTab(product)) return;
      const handle = product.handle || String(product.url || '').split('/products/')[1]?.split(/[?#/]/)[0];
      if (!handle) { product._nrNotPurchasable = true; return; }
      const url = this.nrRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      try {
        if (!window.nrBundleProductCache.has(url)) {
          window.nrBundleProductCache.set(url, this.nrReadJSON(url).catch(error => {
            window.nrBundleProductCache.delete(url); throw error;
          }));
        }
        const fresh = await window.nrBundleProductCache.get(url);
        product.variants = fresh.variants.map(v => ({
          ...v, compareAtPrice: v.compare_at_price || 0,
          image: v.featured_image?.src || v.featured_image || fresh.featured_image || product.image,
          fullImage: v.featured_image?.src || v.featured_image || fresh.featured_image || product.fullImage
        }));
        const variant = product.variants.find(v => v.available);
        if (!variant || fresh.requires_selling_plan) { product._nrNotPurchasable = true; return; }
        Object.assign(product, {variantId:variant.id, variantTitle:variant.title,
          price:variant.price, compareAtPrice:variant.compareAtPrice,
          image:variant.image, fullImage:variant.fullImage, available:true});
      } catch (error) {
        // Do not preselect unverified or unavailable variants.
        product._nrNotPurchasable = true;
        console.warn('Rustfield bundle product unavailable:', handle, error.message);
      }
    };
    // Limit parallel product reads and reuse the same product response across bundle instances.
    for (let i = 0; i < jobs.length; i += 6) await Promise.all(jobs.slice(i, i + 6).map(enrich));
    // No fixed product choices in code: hide empty/incomplete metafield collections until configured.
    this.bundleCollections = collections.filter(col => Array.isArray(col.products) &&
      col.products.some(product => product &&
        ((product.id && !product._nrNotPurchasable) || (product.openInNewTab && product.url))));
    this._nrDefaultColId = null;
    this._nrDefaultProductId = null;
    if (this.nrMainEnabled()) {
      for (const col of this.bundleCollections) {
        const first = (col.products || []).find(p => p.id && !p._nrNotPurchasable && !this.shouldOpenProductInNewTab(p)
          && String(p.id) !== String(this._nrMainProduct?.id));
        if (first) { this._nrDefaultColId = String(col.id); this._nrDefaultProductId = String(first.id); break; }
      }
    }
  }

  nrMainEnabled() { return this.dataset.mainPair !== 'false'; }

  async nrUpdateThemeCart(cart) {
    const drawer = document.querySelector('cart-drawer');
    // Use the theme's actual refresh handler: it retrieves rendered sections,
    // publishes cartUpdate to cart-count/cart-items, then opens the drawer.
    if (drawer && typeof drawer.onCartRefresh === 'function') {
      await drawer.onCartRefresh({detail:{open:true}});
      return;
    }
    if (window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        {cart:{...cart, sections:cart.sections || {}}});
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true, detail:{open:true}}));
  }

  nrMainForm() {
    const formId = this.dataset.mainFormId || 'product-form-' + this.sectionId;
    const form = document.getElementById(formId);
    if (form && form.tagName === 'FORM' && (!form.dataset.productId || !this._nrMainProduct ||
        String(form.dataset.productId) === String(this._nrMainProduct.id))) return form;
    if (!this._nrMainProduct) return null;
    const root = document.getElementById('MainProduct-' + this.sectionId) || this.closest('product-info') || document;
    return Array.from(root.querySelectorAll('form.main-product-form, form[data-product-id], form[action*="/cart/add"]'))
      .find(candidate => !candidate.dataset.productId || String(candidate.dataset.productId) === String(this._nrMainProduct.id)) || null;
  }

  nrMainVariant() {
    const form = this.nrMainForm();
    const input = form?.querySelector('input.product-variant-id[name="id"], input[type="hidden"][name="id"], select[name="id"]');
    if (!input) return {ready:false, available:false};
    const variant = this._nrMainProduct?.variants?.find(v => String(v.id) === String(input.value));
    if (!variant) return {ready:false, available:false};
    // Wait for the theme's canonical hidden variant ID to catch up with picker changes.
    const root = document.getElementById('MainProduct-' + this.sectionId) || this.closest('product-info');
    const picker = root?.querySelector('variant-selects');
    const options = picker ? Array.from(picker.querySelectorAll('fieldset,select')).map(control =>
      control.tagName === 'SELECT' ? control.value : control.querySelector('input:checked')?.value).filter(v => v != null) : [];
    const values = variant.options || [variant.option1, variant.option2, variant.option3].filter(v => v != null);
    const comparable = options.length && options.length === values.length
      && options.every(value => this._nrMainProduct.variants.some(v => (v.options || []).includes(value)));
    if (comparable && options.some((value, index) => value !== values[index])) {
      return {ready:false, available:false};
    }
    return {ready:true, available:variant.available !== false && !input.disabled, variant, form};
  }

  nrRenderMain() {
    if (!this._nrMainProduct || !this.nrMainEnabled()) return;
    let area = this.contentContainer.querySelector('[data-nr-main-area]');
    if (!area) {
      area = document.createElement('div');
      area.className = 'nr-bundle-main-area';
      area.dataset.nrMainArea = '';
      const selectedItems = this.contentContainer.querySelector('.col-items-container');
      if (selectedItems) selectedItems.before(area);
      else (this.contentContainer.querySelector('.bundle-items') || this.contentContainer).append(area);
    }
    if (!this._nrMainIncluded) {
      area.onclick = null;
      area.innerHTML = '<button type="button" class="nr-bundle-restore">Select the product you’re viewing</button>';
      area.querySelector('button').onclick = () => { this._nrMainIncluded = true; this.nrRenderMain(); this.calculateTotal(); };
      return;
    }
    const current = this.nrMainVariant();
    const variant = current.variant || this._nrMainProduct.variants.find(v => String(v.id) === this.dataset.initialVariantId)
      || this._nrMainProduct.variants[0];
    if (!variant) return;
    const form = this.nrMainForm();
    const rule = variant.quantity_rule || {min:1, increment:1};
    const quantity = Math.max(rule.min || 1, Number(form?.elements.namedItem('quantity')?.value) || 1);
    const image = variant.featured_image?.src || variant.featured_image || this._nrMainProduct.featured_image || '';
    const product = {id:this._nrMainProduct.id, title:this._nrMainProduct.title, url:this._nrMainProduct.url,
      price:variant.price, compareAtPrice:variant.compare_at_price || 0, image, fullImage:image, variantId:variant.id};
    area.innerHTML = '<div class="bundle-col-product-group">' + this.renderColItemHTML(product) + '</div>';
    const card = area.querySelector('.bundle-col-item');
    card.dataset.nrMainCard = '';
    card.querySelector('.bundle-dynamic-variant').style.display = '';
    const qty = card.querySelector('.col-qty-input');
    qty.value = quantity;
    area.onclick = event => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.classList.contains('col-item-remove-btn')) {
        this._nrMainIncluded = false; this.nrRenderMain(); this.calculateTotal(); return;
      }
      const snapshot = this.nrMainVariant();
      const r = snapshot.variant?.quantity_rule || {min:1, increment:1};
      const delta = r.increment || 1;
      if (button.classList.contains('col-qty-plus')) qty.value = Math.min(r.max || Infinity, Number(qty.value) + delta);
      if (button.classList.contains('col-qty-minus')) qty.value = Math.max(r.min || 1, Number(qty.value) - delta);
      this.calculateTotal();
    };
    qty.addEventListener('change', () => {
      qty.value = Math.max(1, Math.floor(Number(qty.value) || 1)); this.calculateTotal();
    }, {signal:this._nrAbort.signal});
    this.nrSyncMain();
  }

  nrSyncMain() {
    const card = this.contentContainer.querySelector('[data-nr-main-card]');
    if (!card || !this._nrMainIncluded) return;
    const state = this.nrMainVariant();
    card.dataset.nrAvailable = state.available ? 'true' : 'false';
    const label = card.querySelector('.bundle-dynamic-variant');
    if (!state.ready) { label.textContent = 'Updating selected size / color…'; return; }
    const variant = state.variant;
    card.dataset.variantId = String(variant.id);
    card.dataset.price = String(variant.price);
    card.dataset.compare = String(variant.compare_at_price || 0);
    const variantTitle = variant.title === 'Default Title' ? 'Default' : variant.title;
    label.innerHTML = 'Variants: <a href="#" class="nr-main-variant-link bundle-dynamic-variant-label" title="Change options using the product picker above">'
      + this.nrEscape(variantTitle) + '</a>'
      + (state.available ? '' : ' — unavailable');
    label.classList.remove('bundle-variant-trigger');
    label.querySelector('a').onclick = event => {
      event.preventDefault(); event.stopPropagation(); this.nrScrollToMainPicker();
    };
    card.querySelector('.bundle-dynamic-price').textContent = this.nrMoney(variant.price);
    card.querySelector('.bundle-dynamic-compare-wrapper').innerHTML = variant.compare_at_price > variant.price
      ? '<span class="bundle-item__compare">' + this.nrMoney(variant.compare_at_price) + '</span>' : '';
    const src = variant.featured_image?.src || variant.featured_image || this._nrMainProduct.featured_image;
    const image = card.querySelector('.bundle-dynamic-img');
    if (image && src && image.getAttribute('src') !== src) image.src = src;
    const zoom = card.querySelector('.bundle-dynamic-image-zoom');
    if (zoom && src) zoom.dataset.fullImage = src;
    const qty = card.querySelector('.col-qty-input');
    const rule = variant.quantity_rule || {min:1, increment:1};
    qty.min = rule.min || 1; qty.step = rule.increment || 1;
    if (rule.max) qty.max = rule.max; else qty.removeAttribute('max');
  }

  nrScrollToMainPicker() {
    const form = this.nrMainForm();
    const root = form?.closest('product-info') || document.getElementById('MainProduct-' + this.sectionId) || document;
    const picker = root.querySelector('variant-selects');
    if (!picker) return;
    const control = picker.querySelector('input:checked, select, input:not([disabled]), button');
    control?.focus({preventScroll:true});
    const header = document.querySelector('header');
    const offset = (header?.getBoundingClientRect().height || 0) + 20;
    window.scrollTo({top:Math.max(0, window.scrollY + picker.getBoundingClientRect().top - offset),
      behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }

  nrStartSync() {
    this._nrAbort = this._nrAbort || new AbortController();
    this.nrRenderMain();
    let signature = '';
    const update = () => {
      const form = this.nrMainForm();
      const input = form?.querySelector('.product-variant-id');
      const state = this.nrMainVariant();
      const next = input?.value + '|' + input?.disabled + '|' + state.ready;
      if (next !== signature) { signature = next; this.nrSyncMain(); this.calculateTotal(); }
    };
    this._nrSyncTimer = setInterval(update, 200);
    document.addEventListener('change', event => {
      const root = document.getElementById('MainProduct-' + this.sectionId);
      if (root?.contains(event.target) && !this.contains(event.target)) {
        this.nrSyncMain(); this.calculateTotal();
      }
    }, {signal:this._nrAbort.signal});
    window.addEventListener('bundle:cart-updated', event => {
      if (event.detail?.cart) { this._nrCart = event.detail.cart; this.calculateTotal(); }
    }, {signal:this._nrAbort.signal});
    window.addEventListener('focus', () => this.nrRefreshCart().catch(() => {}), {signal:this._nrAbort.signal});
    // Refresh periodically while visible, to catch cart edits made by theme drawers and other apps.
    this._nrCartTimer = setInterval(() => {
      if (!document.hidden && !this._nrAdding) this.nrRefreshCart().catch(() => {});
    }, 5000);
  }

  async nrRefreshCart() {
    const cart = await this.nrReadJSON(this.nrRoot() + 'cart.js');
    this._nrCart = cart;
    this.calculateTotal();
    return cart;
  }

  nrSelectedRows() {
    const rows = [];
    const main = this.contentContainer.querySelector('[data-nr-main-card]');
    if (this._nrMainIncluded && main) rows.push(main);
    this.contentContainer.querySelectorAll('.bundle-col-container').forEach(wrapper => {
      if (this.collectionStates[wrapper.dataset.colId]?.isActive) rows.push(...Array.from(wrapper.querySelectorAll('.bundle-col-item')).filter(row => !row.hasAttribute('data-nr-main-card')));
    });
    return rows;
  }

  nrDiscountRate(quantity) { return quantity >= 4 ? 15 : quantity >= 2 ? 10 : 0; }

  nrTotals(rows, cart) {
    let subtotal = 0, compare = 0, addedQuantity = 0;
    rows.forEach(row => {
      const quantity = Math.max(1, Math.floor(Number(row.querySelector('.col-qty-input')?.value) || 1));
      const price = Number(row.dataset.price) || 0;
      subtotal += price * quantity;
      compare += Math.max(price, Number(row.dataset.compare) || 0) * quantity;
      addedQuantity += quantity;
    });
    const existingQuantity = cart ? (cart.items || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0) : 0;
    const rate = cart ? this.nrDiscountRate(existingQuantity + addedQuantity) : 0;
    return {subtotal, compare, addedQuantity, existingQuantity, rate,
      estimated:Math.round(subtotal * (100 - rate) / 100)};
  }

  nrSavingsNoteText(quantity) {
    if (quantity >= 4) return 'Save 15% OFF & Free Shipping on your entire cart now';
    if (quantity >= 2) {
      const remaining = 4 - quantity;
      return `Save 10% OFF on your entire cart now. Add ${remaining} more ${remaining === 1 ? 'item' : 'items'} to get 15% OFF & Free Shipping`;
    }
    const remaining = 2 - quantity;
    return `Add ${remaining} more ${remaining === 1 ? 'item' : 'items'} to get 10% OFF.`;
  }

  nrPositionSavingsNote() {
    const note = this.querySelector('[data-nr-bundle-progress]');
    if (!note) return;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const suggestions = this.contentContainer.querySelector('.bundle-collections-wrapper');
    if (mobile && suggestions) {
      if (note.parentElement !== suggestions || suggestions.lastElementChild !== note) suggestions.append(note);
    } else if (note.parentElement !== this.footerContainer.parentElement || note.nextElementSibling !== this.footerContainer) {
      this.footerContainer.before(note);
    }
  }

  nrUpdateSavingsNote(totals) {
    let note = this.querySelector('[data-nr-bundle-progress]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.nrBundleProgress = '';
      note.className = 'nr-bundle-progress';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      this.footerContainer.before(note);
    }
    this.nrPositionSavingsNote();
    const message = this._nrCart
      ? this.nrSavingsNoteText(totals.existingQuantity + totals.addedQuantity)
      : 'Checking your cart…';
    if (note.textContent !== message) {
      note.innerHTML = this.nrEscape(message).replace(/(15% OFF &amp; Free Shipping|\d+% (?:off|OFF))/g, '<strong>$1</strong>');
    }
  }

  nrSetNotice(message, error = false) {
    let notice = this.querySelector('[data-nr-bundle-notice]');
    if (!notice) {
      notice = document.createElement('div'); notice.dataset.nrBundleNotice = '';
      this.footerContainer.insertAdjacentElement('beforebegin', notice);
    }
    notice.textContent = message;
    notice.className = error ? 'nr-bundle-notice nr-bundle-notice--error' : 'nr-bundle-notice';
    notice.setAttribute('role', error ? 'alert' : 'status');
  }

  setupNorthrynBundleHeading() {
    const scope = this.closest('.bundle-test-section') || this;
    // Remove the extra headline from the previous version; use existing titles only.
    scope.querySelectorAll('.nr-bundle-desktop-heading').forEach(el => el.remove());
    scope.querySelectorAll('.nr-bundle-original-heading').forEach(el => {
      el.classList.remove('nr-bundle-original-heading');
    });
    if (!this._nrBundleTitleMedia) {
      this._nrBundleTitleMedia = window.matchMedia('(min-width: 750px)');
      this._nrBundleTitleChange = () => { this.setupNorthrynBundleHeading(); this.nrPositionSavingsNote(); };
      if (this._nrBundleTitleMedia.addEventListener) {
        this._nrBundleTitleMedia.addEventListener('change', this._nrBundleTitleChange);
      } else {
        this._nrBundleTitleMedia.addListener(this._nrBundleTitleChange);
      }
    }
    const desktop = this._nrBundleTitleMedia.matches;
    const titles = scope.querySelectorAll('.bundle-col-title,.bundle-header-title');
    titles.forEach(title => {
      if (!desktop) {
        if (title.textContent.trim() !== 'Buy Bundle & Save 15% + Free Shipping') {
          if (title._nrDesktopHTML === undefined) title._nrDesktopHTML = title.innerHTML;
          title.textContent = 'Buy Bundle & Save 15% + Free Shipping';
        }
        title._nrBuyPrefixNode = null;
        return;
      }
      if (title._nrDesktopHTML !== undefined) {
        title.innerHTML = title._nrDesktopHTML;
        delete title._nrDesktopHTML;
      }
      if (/^bundle\b/i.test(title.textContent.trim())) {
        title.insertBefore(document.createTextNode('Buy '), title.firstChild);
      }
    });
  }

  renderBundleItems() {
    const hasBundleInfo = this.bundleInfo && (this.bundleInfo.title || this.bundleInfo.description || (Array.isArray(this.bundleInfo.discount) && this.bundleInfo.discount.length > 0));
    const hasCollections = this.bundleCollections && this.bundleCollections.length > 0;

    if (!hasBundleInfo || !hasCollections) {
      this.style.display = "none";
      return;
    }

    this.style.display = "block";

    let headerHtml = "";
    if (this.bundleInfo && this.bundleInfo.title) {
      // headerHtml += `<h3 class="bundle-header-title text-center">${this.bundleInfo.title}</h3>`;
      if (this.bundleInfo.description) {
        headerHtml += `<p class="bundle-header-desc text-center">${this.bundleInfo.description}</p>`;
      }
      if (this.bundleInfo.discount && Array.isArray(this.bundleInfo.discount) && this.bundleInfo.discount.length > 0) {
        headerHtml += `<div class="bundle-discount-badges text-center">`;
        this.bundleInfo.discount.forEach((discount) => {
          if (!discount || discount.value <= 0) return;
          const discountTypeSymbol = (discount.type || discount.discountType || "").toLowerCase() === "percentage" ? "%" : "$";
          const dVal = discount.value;
          const defaultLabel = `Buy ${discount.quantity} items get ${discountTypeSymbol === "$" ? "$" : ""}${dVal}${discountTypeSymbol === "%" ? "%" : ""} discount`;
          const labelText = discount.labelText || defaultLabel;
          headerHtml += `<span class="bundle-discount-badge"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path></svg>${labelText}</span>`;
        });
        headerHtml += `</div>`;
      }
    }
    let html = headerHtml + '<div class="bundle-items">';

    // Render bundle collections
    if (hasCollections) {
      this.bundleCollections.forEach((col, colIndex) => {
        const wrapperId = `bundle-col-wrapper-${this.sectionId}-${this.bundleKey}-${colIndex}`;

        // Initialize state based on isDefaultSelected
        const firstProd = col.products?.find(p => String(p.id) === this._nrDefaultProductId) || col.products?.[0] || null;
        const isDefaultSelected = String(col.id) === this._nrDefaultColId && firstProd && !firstProd._nrNotPurchasable;

        if (isDefaultSelected && firstProd) {
          this.collectionStates[col.id] = {
            selectedProducts: [firstProd],
            isActive: true,
          };
        } else {
          this.collectionStates[col.id] = { selectedProducts: [], isActive: false };
        }

        let collectionsHtml = `<div class="bundle-collections-wrapper">`;
        if (col.products && col.products.length > 0) {
          collectionsHtml += `
            <div class="bundle-col-title">${col.name ? col.name : "Add extra items:"}</div>
            <div class="bundle-slider-shell">
              <div class="bundle-slider-container">
          `;
          col.products.forEach((cProd) => {
            collectionsHtml += this.renderCollectionOptionItemHTML(cProd, col.id, wrapperId);
          });
          collectionsHtml += `
              </div>
            </div>`;
        }
        collectionsHtml += `</div>`;
        let colItemsHtml = "";
        if (isDefaultSelected && firstProd) {
          colItemsHtml = `<div class="bundle-col-product-group" data-product-id="${firstProd.id}">${this.renderColItemHTML(firstProd, true)}</div>`;
        }
        html += `
          <div class="bundle-col-container bundle-item-wrapper" id="${wrapperId}" data-col-id="${col.id}" data-is-collection="true">
            <div class="col-collections-wrapper">
              ${collectionsHtml}
              <div class="col-items-container flex flex-col">
                ${colItemsHtml}
              </div>
            </div>
          </div>
        `;
      });
    }

    html += "</div>";
    this.contentContainer.innerHTML = html;
    this.setupNorthrynBundleHeading();

    // Attach events for initial col-items
    this.contentContainer.querySelectorAll(".col-items-container").forEach((container) => {
      this.attachColItemDelegation(container);
    });

    this.attachEvents();
    this.setupBundleSliders();
    this.setupTooltipPositioning();
    this.calculateTotal();
  }

  setupBundleSliders() {
    (this.sliderAutoplayTimers || []).forEach(timer => window.clearInterval(timer));
    this.sliderAutoplayTimers = [];
    this.contentContainer.querySelectorAll('.bundle-slider-shell').forEach(shell => {
      shell.querySelectorAll('.bundle-slider-nav').forEach(button => button.remove());
      const slider = shell.querySelector('.bundle-slider-container');
      if (!slider) return;
      const signal = this._nrAbort.signal;
      let scrollbar = shell.querySelector('.nr-bundle-scrollbar');
      if (!scrollbar) {
        scrollbar = document.createElement('input');
        scrollbar.type = 'range';
        scrollbar.min = '0'; scrollbar.max = '1000'; scrollbar.step = '1';
        scrollbar.value = '0';
        scrollbar.className = 'nr-bundle-scrollbar';
        scrollbar.setAttribute('aria-label', 'Scroll bundle product suggestions');
        shell.append(scrollbar);
      }
      const updateScrollbar = () => {
        const max = Math.max(0, slider.scrollWidth - slider.clientWidth);
        scrollbar.hidden = max <= 1;
        scrollbar.value = max > 0 ? String(Math.round(slider.scrollLeft / max * 1000)) : '0';
      };
      scrollbar.addEventListener('input', () => {
        const behavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = Number(scrollbar.value) / 1000 * Math.max(0, slider.scrollWidth - slider.clientWidth);
        slider.style.scrollBehavior = behavior;
      }, {signal});
      slider.addEventListener('scroll', updateScrollbar, {signal, passive:true});
      window.addEventListener('resize', updateScrollbar, {signal});
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateScrollbar);
        observer.observe(slider);
        Array.from(slider.children).forEach(child => observer.observe(child));
        this._nrSliderResizeObservers = this._nrSliderResizeObservers || [];
        this._nrSliderResizeObservers.push(observer);
      }
      updateScrollbar();
      slider.style.overflowX = 'auto';
      slider.style.touchAction = 'auto';
      slider.style.cursor = 'grab';
      let drag = null, suppressClickUntil = 0, touch = null;
      slider.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        const option = event.target.closest('.bundle-col-option-item');
        touch = option ? {option, id:event.pointerId, x:event.clientX, y:event.clientY, left:slider.scrollLeft} : null;
      }, {signal, passive:true});
      slider.addEventListener('pointercancel', () => {touch = null;}, {signal, passive:true});
      slider.addEventListener('pointerup', event => {
        const start = touch; touch = null;
        if (!start || start.id !== event.pointerId || !this.nrIsProductTap(start,event,slider.scrollLeft)) return;
        if (start.option.matches('a[target="_blank"]')) return;
        this._nrTouchSelection = {option:start.option, time:Date.now()};
        this.nrToggleBundleOption(start.option);
      }, {signal, capture:true});
      slider.addEventListener('dragstart', event => event.preventDefault(), {signal});
      slider.addEventListener('pointerdown', event => {
        // Touch uses native scrolling, preserving vertical page scroll and taps.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = {id:event.pointerId, x:event.clientX, left:slider.scrollLeft, moved:false,
          snap:slider.style.scrollSnapType, behavior:slider.style.scrollBehavior,
          selection:slider.style.userSelect};
      }, {signal});
      document.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const delta = event.clientX - drag.x;
        if (!drag.moved && Math.abs(delta) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          slider.setPointerCapture(event.pointerId);
          slider.style.scrollSnapType = 'none';
          slider.style.scrollBehavior = 'auto';
          slider.style.userSelect = 'none';
          slider.style.cursor = 'grabbing';
        }
        event.preventDefault();
        slider.scrollLeft = drag.left - delta;
      }, {signal, passive:false});
      const finish = event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) {
          suppressClickUntil = Date.now() + 250;
          slider.dataset.nrDraggedUntil = String(suppressClickUntil);
          slider.style.scrollSnapType = drag.snap;
          slider.style.scrollBehavior = drag.behavior;
          slider.style.userSelect = drag.selection;
          if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        }
        slider.style.cursor = 'grab';
        drag = null;
      };
      document.addEventListener('pointerup', finish, {signal});
      document.addEventListener('pointercancel', finish, {signal});
      slider.addEventListener('click', event => {
        if (Date.now() < suppressClickUntil) {event.preventDefault();event.stopImmediatePropagation();}
      }, {signal, capture:true});
    });
  }

  setupTooltipPositioning() {
    this.initSharedTooltip();
    // Bind shared-tooltip behavior for all tooltip triggers in container
    const tooltips = this.contentContainer.querySelectorAll(".bundle-tooltip");
    tooltips.forEach((tooltip) => {
      this.attachTooltipPositioningListener(tooltip);
    });
  }

  attachTooltipPositioningListener(tooltip) {
    if (!tooltip) return;

    const tooltipText = tooltip.querySelector(".bundle-tooltip-text");
    const tooltipContent = (tooltip.dataset.tooltipText || (tooltipText ? tooltipText.textContent : "") || "").trim();
    if (!tooltipContent) return;

    if (tooltip.dataset.tooltipListenerAttached === "true") return;
    tooltip.dataset.tooltipListenerAttached = "true";
    tooltip.dataset.tooltipText = tooltipContent;

    if (tooltipText) {
      tooltipText.style.display = "none";
    }

    tooltip.setAttribute("tabindex", "0");

    tooltip.addEventListener("mouseenter", () => {
      if (this.isCoarsePointer()) return;
      this.showSharedTooltip(tooltip);
    });

    tooltip.addEventListener("mouseleave", () => {
      if (this.isCoarsePointer()) return;
      this.hideSharedTooltip();
    });

    tooltip.addEventListener("focus", () => {
      this.showSharedTooltip(tooltip);
    });

    tooltip.addEventListener("blur", () => {
      this.hideSharedTooltip();
    });

    tooltip.setAttribute('role', 'button');
    tooltip.setAttribute('aria-label', 'Personalization instructions');
    this.nrBindTap(tooltip, () => tooltip, () => this.showSharedTooltip(tooltip));
    tooltip.addEventListener('keydown', event => {
      if (event.key === 'Escape') { this.hideSharedTooltip(); return; }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); this.showSharedTooltip(tooltip);
      }
    });
  }

  initSharedTooltip() {
    if (!this.sharedTooltipEl) {
      const tooltipEl = document.createElement("div");
      tooltipEl.className = "bundle-shared-tooltip";
      tooltipEl.setAttribute("role", "tooltip");
      document.body.appendChild(tooltipEl);
      this.sharedTooltipEl = tooltipEl;
    }

    if (!this._onTooltipDocumentClick) {
      this._onTooltipDocumentClick = (e) => {
        if (!this.activeTooltipTrigger) return;
        const trigger = e.target.closest?.(".bundle-tooltip");
        const clickedInsideShared = this.sharedTooltipEl && this.sharedTooltipEl.contains(e.target);
        if (clickedInsideShared || trigger === this.activeTooltipTrigger) return;
        this.hideSharedTooltip();
      };
      // Capture observes outside taps even if another widget stops bubbling.
      // Do not cancel the event: the same tap must still focus the text field.
      for (const name of ['pointerdown','touchstart','click','focusin']) {
        document.addEventListener(name, this._onTooltipDocumentClick, {capture:true, passive:true});
      }
    }

    if (!this._onTooltipViewportChange) {
      this._onTooltipViewportChange = () => {
        this.repositionSharedTooltip();
      };
      window.addEventListener("resize", this._onTooltipViewportChange);
      window.addEventListener("scroll", this._onTooltipViewportChange, true);
    }
  }

  isCoarsePointer() {
    return !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
  }

  showSharedTooltip(tooltipTrigger) {
    if (!this.sharedTooltipEl || !tooltipTrigger) return;

    const content = (tooltipTrigger.dataset.tooltipText || "").trim();
    if (!content) return;

    this.activeTooltipTrigger = tooltipTrigger;
    this.sharedTooltipEl.textContent = content;
    this.sharedTooltipEl.classList.add("is-visible");
    this.repositionSharedTooltip();
  }

  hideSharedTooltip() {
    if (!this.sharedTooltipEl) return;
    this.sharedTooltipEl.classList.remove("is-visible", "is-bottom");
    this.activeTooltipTrigger = null;
  }

  repositionSharedTooltip() {
    if (!this.sharedTooltipEl || !this.activeTooltipTrigger || !this.sharedTooltipEl.classList.contains("is-visible")) {
      return;
    }

    const triggerRect = this.activeTooltipTrigger.getBoundingClientRect();
    const tooltipRect = this.sharedTooltipEl.getBoundingClientRect();
    const gap = 10;
    const viewportPadding = 10;

    let left = triggerRect.left + triggerRect.width / 2;
    const minCenterX = viewportPadding + tooltipRect.width / 2;
    const maxCenterX = window.innerWidth - viewportPadding - tooltipRect.width / 2;
    left = Math.max(minCenterX, Math.min(maxCenterX, left));

    let top = triggerRect.top - tooltipRect.height - gap;
    let showBottom = false;

    if (top < viewportPadding) {
      top = triggerRect.bottom + gap;
      showBottom = true;
    }

    if (top + tooltipRect.height > window.innerHeight - viewportPadding) {
      top = Math.max(viewportPadding, window.innerHeight - viewportPadding - tooltipRect.height);
    }

    this.sharedTooltipEl.style.left = `${left}px`;
    this.sharedTooltipEl.style.top = `${top}px`;
    this.sharedTooltipEl.classList.toggle("is-bottom", showBottom);
  }

  normalizeInputTypes(rawInputTypes) {
    let parsed = rawInputTypes;

    if (typeof parsed === "string") {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        parsed = null;
      }
    }

    let list = [];
    if (Array.isArray(parsed)) {
      list = parsed;
    } else if (parsed && typeof parsed === "object") {
      list = [parsed];
    }

    const result = list.filter(Boolean).map((it) => ({
      type: it.type || "",
      label: it.label || "",
      required: it.required === true || it.required === "true",
      placeholder: it.placeholder || "",
      description_optional: it.description_optional || it.description || "",
    }));

    return result;
  }

  getProductInputTypes(product) {
    return this.normalizeInputTypes(product ? product.inputTypes : null);
  }

  getColItemInputTypes(colItem) {
    const inputTypesFromDataset = colItem ? colItem.dataset.inputTypes : null;

    return this.normalizeInputTypes(inputTypesFromDataset);
  }

  buildInputTypesDataAttr(inputTypes) {
    const normalized = this.normalizeInputTypes(inputTypes);
    return JSON.stringify(normalized).replace(/"/g, "&quot;");
  }

  getTextInputTypes(inputTypes) {
    return inputTypes.filter((it) => (it.type || "") === "Text Input");
  }

  getAllInputTypes(inputTypes) {
    return inputTypes.filter((it) => it.type && (it.type === "Text Input" || it.type === "Image"));
  }

  shouldOpenProductInNewTab(product) {
    return product?.openInNewTab === true;
  }

  renderCollectionOptionItemHTML(cProd, colId, targetWrapperId) {
    const openInNewTab = this.shouldOpenProductInNewTab(cProd);
    const tagName = openInNewTab ? "a" : "div";
    const productUrl = (cProd.url || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const linkAttributes = openInNewTab ? `href="${productUrl}" target="_blank" rel="noopener noreferrer"` : "";
    const state = this.collectionStates[colId];
    const currentVarId = String(cProd.variantId || cProd.id || "");
    const isSelected = state && state.selectedProducts.some((p) => String(p.variantId || p.id || "") === currentVarId);
    const inputTypesDataAttr = this.buildInputTypesDataAttr(cProd.inputTypes);

    const cPriceStr = cProd.price ? (cProd.price / 100).toFixed(2) : "0.00";
    const cCompareStr = cProd.compareAtPrice > cProd.price ? `<span class="bundle-option-item__compare">$${(cProd.compareAtPrice / 100).toFixed(2)}</span>` : "";

    return `
      <${tagName} class="bundle-option-item bundle-col-option-item ${isSelected ? "selected" : ""}"
        ${linkAttributes}
        data-col-id="${colId}"
        data-target-wrapper="${targetWrapperId}"
        data-product-id="${cProd.id}"
        data-variant-id="${currentVarId}"
        data-title="${(cProd.title || "").replace(/"/g, "&quot;")}"
        data-price="${cProd.price}"
        data-compare="${cProd.compareAtPrice || 0}"
        data-image="${cProd.image}"
        data-full-image="${cProd.fullImage}"
        data-url="${cProd.url}"
        data-variant-title="${cProd.variantTitle || ""}"
        data-input-types="${inputTypesDataAttr}"
      >
        ${openInNewTab ? "" : '<div class="bundle-option-check">✓</div>'}
        <div class="bundle-option-item__image">
          <img src="${cProd.image}" alt="${(cProd.title || "").replace(/"/g, "&quot;")}">
        </div>
        <div class="bundle-option-item__title" title="${(cProd.title || "").replace(/"/g, "&quot;")}">${cProd.title}</div>
        <div class="bundle-option-item__price">$${cPriceStr}${cCompareStr}</div>
      </${tagName}>
    `;
  }

  nrToggleBundleOption(optionEl) {
        // Link-only upsells use native navigation and never change bundle selection.
        if (optionEl.matches('a[target="_blank"]')) return;
        const sourceCol = this.bundleCollections.find(col => String(col.id) === String(optionEl.dataset.colId));
        const sourceProduct = sourceCol?.products.find(p => String(p.id) === String(optionEl.dataset.productId));
        if (sourceProduct?._nrNotPurchasable) {
          this.nrSetNotice('This product is unavailable for adding. Please choose another product.', true);
          return;
        }
        const colId = optionEl.dataset.colId;
        const targetWrapperId = optionEl.dataset.targetWrapper;
        const targetWrapper = this.contentContainer.querySelector(`#${targetWrapperId}`);

        if (!targetWrapper || !this.collectionStates[colId]) return;

        const itemsContainer = targetWrapper.querySelector(".col-items-container");
        const state = this.collectionStates[colId];

        const isSelected = optionEl.classList.contains("selected");
        const currentVariantId = optionEl.dataset.variantId;

        const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
        const originalProd = collection ? collection.products.find((p) => String(p.variantId || p.id || "") === String(currentVariantId)) : null;

        const newProductData = originalProd
          ? JSON.parse(JSON.stringify(originalProd))
          : {
              id: optionEl.dataset.productId,
              variantId: currentVariantId,
              price: optionEl.dataset.price,
              compareAtPrice: optionEl.dataset.compare,
              title: optionEl.dataset.title,
              image: optionEl.dataset.image,
              fullImage: optionEl.dataset.fullImage,
              url: optionEl.dataset.url,
              variantTitle: optionEl.dataset.variantTitle,
              inputType: optionEl.dataset.inputType,
              inputLabel: optionEl.dataset.inputLabel,
              isRequired: optionEl.dataset.isRequired === "true",
              description: optionEl.dataset.description,
              placeholder: optionEl.dataset.placeholder,
              inputTypes: this.normalizeInputTypes(
                optionEl.dataset.inputTypes,
                optionEl.dataset.inputType,
                optionEl.dataset.inputLabel,
                optionEl.dataset.isRequired === "true",
                optionEl.dataset.placeholder,
                optionEl.dataset.description,
              ),
              variants: null,
            };

        if (!newProductData.variants && collection && collection.products) {
          const masterProd = collection.products.find((p) => String(p.id) === String(newProductData.id));
          if (masterProd && masterProd.variants) {
            newProductData.variants = masterProd.variants;
          }
        }
        if (isSelected) {
          const productId = optionEl.dataset.productId;

          optionEl.classList.remove("selected");

          // Remove entire product group wrapper
          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          if (productGroup) {
            productGroup.remove();
          }

          const syncedState = this.syncCollectionStateFromContainer(targetWrapper);
        } else {
          state.selectedProducts.push(newProductData);

          optionEl.classList.add("selected");

          const colItemHtml = this.renderColItemHTML(newProductData);
          const groupHtml = `<div class="bundle-col-product-group" data-product-id="${newProductData.id}">${colItemHtml}</div>`;
          itemsContainer.insertAdjacentHTML("beforeend", groupHtml);
          const newGroup = itemsContainer.lastElementChild;
          const newItem = newGroup.firstElementChild;
          // Setup tooltip positioning for new item
          const tooltips = newItem.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });
          if (state.selectedProducts.length === 1) {
            state.isActive = true;
          }
          this.syncCollectionStateFromContainer(targetWrapper);
        }

        this.calculateTotal();
  }

  nrIsProductTap(start, event, scrollLeft) {
    return !!start && Math.abs(event.clientX - start.x) <= 10
      && Math.abs(event.clientY - start.y) <= 10
      && Math.abs(scrollLeft - start.left) <= 8;
  }

  nrBindTap(root, resolveTarget, action) {
    let start = null, last = null;
    const options = {capture:true, signal:this._nrAbort.signal};
    root.addEventListener('pointerdown', event => {
      const target = resolveTarget(event.target);
      if (event.pointerType === 'mouse' || !target || event.isPrimary === false) { start = null; return; }
      start = {target, id:event.pointerId, x:event.clientX, y:event.clientY,
        scrollX:window.scrollX || 0, scrollY:window.scrollY || 0};
    }, options);
    root.addEventListener('pointercancel', () => { start = null; }, options);
    root.addEventListener('pointerup', event => {
      const tap = start; start = null;
      if (!tap || tap.id !== event.pointerId || resolveTarget(event.target) !== tap.target
        || Math.abs(event.clientX-tap.x)>10 || Math.abs(event.clientY-tap.y)>10
        || Math.abs((window.scrollX || 0)-tap.scrollX)>8 || Math.abs((window.scrollY || 0)-tap.scrollY)>8) return;
      last = {target:tap.target, time:Date.now()};
      event.preventDefault(); event.stopPropagation();
      action(tap.target);
    }, options);
    root.addEventListener('click', event => {
      const target = resolveTarget(event.target);
      if (!target) return;
      event.preventDefault(); event.stopPropagation();
      if (event.detail !== 0 && last?.target === target && Date.now()-last.time<700) return;
      action(target);
    }, options);
  }

  nrOpenVariantTrigger(trigger) {
    const item = trigger.closest('.bundle-col-item');
    if (!item) return;
    const primary = item.dataset.isVariantAddon === 'true'
      ? this.findPrimaryItemByProductId(item.closest('.bundle-col-container'), item.dataset.productId) : item;
    if (primary) this.openVariantPopup(primary);
  }

  attachEvents() {
    this.nrBindTap(this.contentContainer,
      target => target.closest?.('input,textarea,select,[contenteditable]') ? null : target.closest?.('.bundle-variant-trigger'),
      trigger => this.nrOpenVariantTrigger(trigger));
    if (this._nrInputEvents) {
      for (const name of ['pointerdown','touchstart','click','keydown']) {
        this.contentContainer.removeEventListener(name, this._nrInputEvents);
      }
    }
    this._nrInputEvents = event => {
      if (!event.target.matches?.('.col-custom-property-input')) return;
      this.hideSharedTooltip();
      event.stopPropagation();
    };
    for (const name of ['pointerdown','touchstart','click','keydown']) {
      this.contentContainer.addEventListener(name, this._nrInputEvents, {signal:this._nrAbort.signal});
    }
    // One delegated handler, also effective when theme handlers intercept bubbling clicks.
    if (this._nrOptionClick) this.contentContainer.removeEventListener('click', this._nrOptionClick, true);
    this._nrOptionClick = event => {
      if (event.target.closest?.('input,textarea,select,[contenteditable],label')) return;
      const option = event.target.closest('.bundle-col-option-item');
      if (!option || !this.contentContainer.contains(option) || option.matches('a[target="_blank"]')) return;
      const slider = option.closest('.bundle-slider-container');
      event.preventDefault(); event.stopPropagation();
      if (Date.now() < Number(slider?.dataset.nrDraggedUntil || 0)) return;
      if (this._nrTouchSelection?.option === option && Date.now() - this._nrTouchSelection.time < 700) return;
      this.nrToggleBundleOption(option);
    };
    this.contentContainer.addEventListener('click', this._nrOptionClick, {capture:true, signal:this._nrAbort.signal});
    this.contentContainer.querySelectorAll('.bundle-col-option-item:not(a)').forEach(option => {
      option.setAttribute('role','button'); option.tabIndex = 0;
    });
    if (this._nrOptionKey) this.contentContainer.removeEventListener('keydown',this._nrOptionKey);
    this._nrOptionKey = event => {
      if (event.target.closest?.('input,textarea,select,[contenteditable]')) return;
      const trigger = event.target.closest('.bundle-variant-trigger');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); this.nrOpenVariantTrigger(trigger); return;
      }
      const option = event.target.closest('.bundle-col-option-item:not(a)');
      if (option && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); this.nrToggleBundleOption(option);
      }
    };
    this.contentContainer.addEventListener('keydown',this._nrOptionKey,{signal:this._nrAbort.signal});


    if (this.addToCartBtn) {
      if (!this._nrAddClick) this._nrAddClick = this.handleAddToCart.bind(this);
      this.addToCartBtn.removeEventListener('click', this._nrAddClick);
      this.addToCartBtn.addEventListener('click', this._nrAddClick);
    }
  }

  calculateTotal() {
    if (!this.contentContainer || !this.collectionStates) return;
    const rows = this.nrSelectedRows();
    const totals = this.nrTotals(rows, this._nrCart);
    this.nrUpdateSavingsNote(totals);
    const unavailable = rows.some(row => row.hasAttribute('data-nr-main-card') && row.dataset.nrAvailable !== 'true');
    if (this.totalContainer) {
      this.totalContainer.innerHTML = `<div class="nr-bundle-total-label">You Save:</div>
        <div class="nr-bundle-total-prices"><strong>${this.nrMoney(totals.estimated)}</strong>
        ${totals.compare > totals.estimated ? `<strike>${this.nrMoney(totals.compare)}</strike>` : ''}</div>
`;
    }
    this.footerContainer.style.display = rows.length ? 'block' : 'none';
    if (this.addToCartBtn) {
      const span = this.addToCartBtn.querySelector('span') || this.addToCartBtn;
      span.textContent = this._nrAdding ? 'Adding…' : 'ADD BUNDLE TO CART';
      this.addToCartBtn.disabled = !!this._nrAdding || !rows.length || unavailable;
    }
  }

  async handleAddToCart(event) {
    event?.preventDefault();
    if (this._nrAdding || window.nrBundleCartBusy) return;
    this._nrAdding = true;
    window.nrBundleCartBusy = true;
    this.calculateTotal();
    let addedCount = 0;
    let requestSent = false;
    try {
      await this.nrRefreshCart();
      if (this._nrMainIncluded && this.nrMainEnabled()) {
        const deadline = Date.now() + 3000;
        while (!this.nrMainVariant().ready && Date.now() < deadline) await new Promise(resolve => setTimeout(resolve, 80));
        const main = this.nrMainVariant();
        if (!main.ready || !main.available) throw new Error('Please choose an available size and color above, or remove this product from the bundle.');
        if (!main.form.reportValidity()) throw new Error('Please complete the required product options above.');
        this.nrSyncMain();
      }
      const rows = this.nrSelectedRows();
      if (!rows.length) throw new Error('Please select at least one product.');
      const items = [];
      for (const row of rows) {
        const id = Number(row.dataset.variantId);
        const quantityInput = row.querySelector('.col-qty-input');
        const quantity = Number(quantityInput?.value || 1);
        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) {
          throw new Error('Please check the selected variant and quantity.');
        }
        const properties = {}, files = {};
        let selling_plan = null;
        if (row.hasAttribute('data-nr-main-card')) {
          const current = this.nrMainVariant();
          if (!current.ready || !current.available || Number(current.variant.id) !== id) throw new Error('Your variant is updating. Please try again after the size/color updates.');
          const rule = current.variant.quantity_rule || {min:1, increment:1};
          if (quantity < (rule.min || 1) || (rule.max && quantity > rule.max) || (quantity - (rule.min || 1)) % (rule.increment || 1)) {
            throw new Error('Please use a valid quantity for the current product.');
          }
          for (const [name, value] of new FormData(current.form)) {
            const match = name.match(/^properties\[(.*)\]$/);
            if (match) {
              if (value instanceof File && value.size) { this.validateFileSize(value); files[match[1]] = value; }
              else if (!(value instanceof File) && value !== '') properties[match[1]] = value;
            }
            if (name === 'selling_plan' && value) selling_plan = Number(value);
          }
          if (this._nrMainProduct.requires_selling_plan && !selling_plan) throw new Error('Please choose the required purchase plan above.');
        } else {
          const wrapper = row.closest('.bundle-col-container');
          const col = this.bundleCollections.find(col => String(col.id) === String(wrapper?.dataset.colId));
          const product = col?.products.find(product => String(product.id) === String(row.dataset.productId));
          const variant = product?.variants?.find(v => Number(v.id) === id);
          if (product?._nrNotPurchasable || (variant && variant.available === false)) throw new Error('One selected variant is unavailable. Please choose another variant.');
          for (const input of row.querySelectorAll('.col-custom-property-input')) {
            const fileInput = input.classList.contains('bundle-image-input');
            const value = fileInput ? input.files?.[0] : input.value.trim();
            const required = input.dataset.isRequired === 'true';
            const error = input.parentElement.querySelector('.custom-property-error');
            if (error) error.style.display = 'none';
            input.style.borderColor = '#ccc';
            if (required && !value) {
              input.style.borderColor = '#D12B37';
              if (error) error.style.display = 'block';
              input.focus(); throw new Error('Please complete the required personalization fields.');
            }
            if (value) {
              const name = input.dataset.propertyName || 'Personalization';
              if (fileInput) { this.validateFileSize(value); files[name] = value; }
              else properties[name] = value;
            }
          }
        }
        const item = {id, quantity, properties, files};
        if (selling_plan) item.selling_plan = selling_plan;
        items.push(item);
      }
      const hasFiles = items.some(item => Object.keys(item.files).length);
      if (!hasFiles) {
        // One multi-item request for ordinary products and text personalization.
        requestSent = true;
        await this.nrReadJSON(this.nrRoot() + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({items:items.map(({files,...item}) => item)})
        });
        addedCount = items.reduce((sum, item) => sum + item.quantity, 0);
      } else {
        // Preserve Shopify's native file-property upload flow; never retry a partial add automatically.
        for (const item of items) {
          const body = new FormData();
          body.append('id', item.id); body.append('quantity', item.quantity);
          if (item.selling_plan) body.append('selling_plan', item.selling_plan);
          for (const [name,value] of Object.entries(item.properties)) body.append(`properties[${name}]`, value);
          for (const [name,value] of Object.entries(item.files)) body.append(`properties[${name}]`, value);
          requestSent = true;
          await this.nrReadJSON(this.nrRoot() + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body});
          addedCount += item.quantity;
        }
      }
      let cart;
      try { cart = await this.nrRefreshCart(); }
      catch (error) {
        this.nrSetNotice('Your items were added, but the updated cart could not be loaded. Please check your cart before adding again.', true);
        return;
      }
      try { await this.nrUpdateThemeCart(cart); } catch (refreshError) { console.warn('Bundle cart display refresh failed:', refreshError); }
      window.dispatchEvent(new CustomEvent('bundle:cart-updated', {detail:{cart}, bubbles:true}));
      this.nrSetNotice('');
    } catch (error) {
      const prefix = addedCount ? `${addedCount} items were already added. ` : '';
      const suffix = requestSent ? ' Check your cart before trying again.' : '';
      this.nrSetNotice(prefix + error.message + suffix, true);
      if (requestSent) await this.nrRefreshCart().catch(() => {});
    } finally {
      this._nrAdding = false; window.nrBundleCartBusy = false; this.calculateTotal();
    }
  }

  validateFileSize(file) {
    if (file.size > 5 * 1024 * 1024) throw new Error('Uploaded files must be 5MB or smaller.');
    return true;
  }

  updateItemFromVariant(item, checkedInput) {
    if (!item || !checkedInput) return;

    // Save existing custom input values BEFORE updating variantId (which changes input ids)
    const inputWrapper = item.querySelector(".bundle-item__custom-input");
    const savedInputValues = [];
    if (inputWrapper) {
      inputWrapper.querySelectorAll(".col-custom-property-input").forEach((inp) => {
        savedInputValues.push(inp.value);
      });
    }

    item.dataset.variantId = checkedInput.value;
    item.dataset.price = checkedInput.dataset.price;
    item.dataset.compare = checkedInput.dataset.compare || "0";
    if (checkedInput.dataset.inputType) item.dataset.inputType = checkedInput.dataset.inputType;
    if (checkedInput.dataset.inputLabel) item.dataset.inputLabel = checkedInput.dataset.inputLabel;
    if (checkedInput.dataset.isRequired) item.dataset.isRequired = checkedInput.dataset.isRequired;
    if (checkedInput.dataset.placeholder) item.dataset.placeholder = checkedInput.dataset.placeholder;
    if (checkedInput.dataset.description) item.dataset.description = checkedInput.dataset.description;
    if (checkedInput.dataset.inputTypes) item.dataset.inputTypes = checkedInput.dataset.inputTypes;

    const fPrice = parseFloat(checkedInput.dataset.price) || 0;
    const fCompare = parseFloat(checkedInput.dataset.compare) || 0;

    const priceEl = item.querySelector(".bundle-dynamic-price");
    if (priceEl) priceEl.textContent = "$" + (fPrice / 100).toFixed(2);

    const compareWrapper = item.querySelector(".bundle-dynamic-compare-wrapper");
    if (compareWrapper) {
      if (fCompare > fPrice) {
        compareWrapper.innerHTML = `<span class="bundle-item__compare bundle-dynamic-compare">$${(fCompare / 100).toFixed(2)}</span>`;
      } else {
        compareWrapper.innerHTML = "";
      }
    }

    const variantTitleEl = item.querySelector(".bundle-dynamic-variant");
    if (variantTitleEl) {
      const fTitle = checkedInput.dataset.variantTitle;
      const labelEl = variantTitleEl.querySelector(".bundle-dynamic-variant-label");
      if (fTitle && fTitle !== "Default Title") {
        variantTitleEl.style.display = "";
        if (labelEl) {
          labelEl.textContent = fTitle;
        } else {
          // Rebuild inner content if label span missing (non-trigger variant p)
          variantTitleEl.innerHTML = `Variants: <span class="bundle-dynamic-variant-label" style="text-decoration: underline;">${fTitle}</span> <span class="bundle-variants-arrow">▼</span>`;
        }
      } else {
        if (variantTitleEl.classList.contains("bundle-variant-trigger")) {
          variantTitleEl.style.display = "";
          if (labelEl) labelEl.textContent = "Select Variant";
        } else {
          variantTitleEl.style.display = "none";
        }
      }
    }

    const imgEl = item.querySelector(".bundle-dynamic-img");
    const fImg = checkedInput.dataset.image;
    if (imgEl && fImg && fImg !== "undefined") {
      if (imgEl.tagName === "IMG") {
        imgEl.src = fImg;
      } else {
        const newImgHtml = `<img src="${fImg}" alt="${checkedInput.dataset.title}" class="bundle-dynamic-img" />`;
        imgEl.outerHTML = newImgHtml;
      }
    }

    const zoomWrapper = item.querySelector(".bundle-dynamic-image-zoom");
    const fFullImg = checkedInput.dataset.fullImage;
    if (zoomWrapper && fFullImg && fFullImg !== "undefined") {
      zoomWrapper.dataset.fullImage = fFullImg;
    }

    // Restore saved input values after variant update
    if (inputWrapper && savedInputValues.length > 0) {
      const currentInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
      currentInputs.forEach((inp, i) => {
        if (i < savedInputValues.length) {
          inp.value = savedInputValues[i];
        }
      });
    }
  }

  renderVariantsAccordionHTML(product, selectedVariantId, fallbackImage, fallbackFullImage) {
    if (!product.variants || product.variants.length <= 1) return "";

    const inputTypesDataAttr = this.buildInputTypesDataAttr(product.inputTypes);

    const variantsDataHtml = product.variants
      .map((v) => {
        const vUrl = product.url || "#";
        const vTitle = product.title || "";
        const vVariantTitle = v.title || "";
        const vProductId = product.id || "";
        const vImage = v.image ? v.image : fallbackImage;
        const vFullImage = v.fullImage ? v.fullImage : fallbackFullImage;
        const isChecked = v.id == selectedVariantId;
        return `
          <input type="checkbox" class="bundle-variant-checkbox" value="${v.id}"
            data-price="${v.price}"
            data-compare="${v.compareAtPrice || 0}"
            data-title="${(vTitle || "").replace(/"/g, "&quot;")}"
            data-variant-title="${(vVariantTitle || "").replace(/"/g, "&quot;")}"
            data-image="${vImage}"
            data-full-image="${vFullImage}"
            data-url="${vUrl}"
            data-product-id="${vProductId}"
            data-input-types="${inputTypesDataAttr}"
            ${isChecked ? "checked" : ""} ${!v.available ? "disabled" : ""}
            style="display:none;"
          />
        `;
      })
      .join("");

    return `<div class="bundle-variants-data" style="display:none;">${variantsDataHtml}</div>`;
  }

  renderColItemHTML(product) {
    const variantId = product.variantId || product.id;
    const title = this.nrEscape(product.title || "Product");
    const url = product.url || "#";
    const price = product.price || 0;
    const compareAtPrice = product.compareAtPrice || 0;
    const image = product.image || "";
    const fullImage = product.fullImage || image;
    const productId = product.id || "";
    const inputTypesDataAttr = this.buildInputTypesDataAttr(product.inputTypes);

    const priceInDollars = (price / 100).toFixed(2);
    const originalPriceHtml = this.renderComparePriceHTML(compareAtPrice, price);
    const removeButtonHtml = this.renderRemoveButtonHTML(variantId);
    // const addButtonHtml = this.renderAddButtonHTML(product.id);
    const variantsDataHtml = this.renderVariantsAccordionHTML(product, variantId, image, fullImage);

    return `
      <div class="bundle-col-item"
        data-url="${url}"
        data-product-title="${(title || "").replace(/"/g, "&quot;")}"
        data-product-id="${productId}"
        data-variant-id="${variantId}"
        data-price="${price}"
        data-compare="${compareAtPrice}"
        data-input-types="${inputTypesDataAttr}"
        data-can-be-added="${product.canBeAdded || false}"
      >
        <div class="bundle-main-details">
          <div class="flex-shrink-0 flex flex-col gap-2 bundle-col-item__image-col">
            ${this.renderImageWrapperHTML(image, title, fullImage, productId)}
            ${removeButtonHtml}
          </div>
          <div class="bundle-item__info flex-grow flex flex-col" style="width: calc(100% - 100px);">
            <p class="bundle-item__title m-0 leading-snug text-gray-900"><a href="${url}" class="bundle-dynamic-url" target="_blank">${title}</a></p>
            ${this.renderVariantDisplayHTML(product, variantsDataHtml)}
            ${variantsDataHtml}
            ${this.renderCustomInputHTML(product, variantId)}
            <div class="flex items-center justify-between bundle-item_footer">
              <div class="bundle-item__prices flex items-center">
                <span class="bundle-item__price font-bold bundle-dynamic-price">$${priceInDollars}</span>
                <span class="bundle-dynamic-compare-wrapper">${originalPriceHtml}</span>
              </div>
              <div class="bundle-item__quantity flex items-center">
                <button type="button" class="col-qty-btn col-qty-minus" data-variant-id="${variantId}">−</button>
                <input type="number" class="col-qty-input text-center bg-transparent border-none bundle-dynamic-qty-input" value="1" min="1" data-variant-id="${variantId}" />
                <button type="button" class="col-qty-btn col-qty-plus" data-variant-id="${variantId}">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderComparePriceHTML(compareAtPrice, price) {
    if (compareAtPrice <= price) return "";
    return `<span class="bundle-item__compare">$${(compareAtPrice / 100).toFixed(2)}</span>`;
  }

  renderRemoveButtonHTML(variantId) {
    return `<button type="button" class="col-item-remove-btn addon-remove-btn" data-variant-id="${variantId}">&times;</button>`;
  }

  renderAddButtonHTML(productId) {
    return "";
  }

  renderImageWrapperHTML(image, title, fullImage, productId) {
    const imgContent = image ? `<img src="${image}" alt="${title}" class="bundle-dynamic-img" />` : '<div class="bundle-dynamic-no-img">No Image</div>';

    return `
      <div class="wrapper-image-bundle">
        <image-zoom-wrapper class="bundle-item__image bundle-dynamic-image-zoom" data-full-image="${fullImage}" title="Click to zoom">
          ${imgContent}
          <div class="bundle-col-item__zoom-icon">
            <svg fill="none"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
          </div>
        </image-zoom-wrapper>
        ${this.renderAddButtonHTML(productId)}
      </div>
    `;
  }

  renderVariantDisplayHTML(product, variantsDataHtml) {
    if (!variantsDataHtml) {
      return `<p class="bundle-item__variant text-blue-600 bundle-dynamic-variant" style="display:none;"></p>`;
    }

    const variantLabel =
      product.variantTitle && product.variantTitle !== "Default Title"
        ? `Variants: <span class="bundle-dynamic-variant-label" style="text-decoration: underline;">${product.variantTitle}</span>`
        : `Select Variant`;

    return `
      <p class="bundle-item__variant text-blue-600 bundle-dynamic-variant bundle-variant-trigger" role="button" tabindex="0" aria-haspopup="dialog" style="cursor:pointer;">
        ${variantLabel}
        <span class="bundle-variants-arrow">▼</span>
      </p>
    `;
  }

  nrCustomInputDisplayLabel(label) {
    return /^Upload\s+Your\s+Text:?\s*$/i.test(String(label).trim()) ? 'Your Text' : label;
  }

  renderCustomInputHTML(product, variantId) {
    const inputTypes = this.getAllInputTypes(this.getProductInputTypes(product));
    if (!inputTypes.length) return "";

    const fieldsHtml = inputTypes
      .map((inputDef, index) => {
        const inputLabel = inputDef.label || "Customize";
        const displayLabel = this.nrEscape(this.nrCustomInputDisplayLabel(inputLabel));
        const required = inputDef.required ? ' <span style="color: red; margin-left: 2px;">*</span>' : "";
        const inputId = `col-custom-input-${variantId}-${index}`;
        const tooltip = this.renderCustomInputTooltipHTML(inputDef.description_optional);

        if (inputDef.type === "Image") {
          return `
            <div class="bundle-custom-input-group">
              <label class="bundle-custom-input-label block flex items-center flex-wrap" for="${inputId}">
                ${displayLabel}${required}:
                ${tooltip}
              </label>
              <input type="file" id="${inputId}" class="bundle-custom-input bundle-image-input custom-property-input col-custom-property-input"
                accept="image/*"
                data-property-name="${inputLabel}"
                data-input-type="Image"
                data-is-required="${inputDef.required}"
              />
              <small style="color: #666; margin-top: 4px; display: block;">Max file size: 5MB</small>
              <div class="custom-property-error">${displayLabel} is required.</div>
            </div>
          `;
        }

        // Default: Text Input
        const placeholder = this.getCustomInputPlaceholder({
          inputLabel: inputLabel,
          placeholder: inputDef.placeholder,
        });
        return `
          <div class="bundle-custom-input-group">
            <label class="bundle-custom-input-label block flex items-center flex-wrap" for="${inputId}">
              ${displayLabel}${required}:
              ${tooltip}
            </label>
            <input type="text" id="${inputId}" class="bundle-custom-input custom-property-input col-custom-property-input"
              placeholder="${placeholder}"
              data-property-name="${inputLabel}"
              data-input-type="Text Input"
              data-is-required="${inputDef.required}"
            />
            <div class="custom-property-error">${displayLabel} is required.</div>
          </div>
        `;
      })
      .join("");

    return `
      <div class="bundle-item__custom-input w-full">
        ${fieldsHtml}
      </div>
    `;
  }

  getCustomInputPlaceholder(product) {
    const inputLabel = product.inputLabel || "Customize Your Stole";
    if (product.placeholder && product.placeholder !== "null") {
      return product.placeholder;
    }
    return `Enter ${inputLabel}...`;
  }

  renderCustomInputTooltipHTML(description) {
    if (!description || description === "null") return "";

    return `
      <div class="bundle-tooltip">
        ?
        <div class="bundle-tooltip-text">${description}</div>
      </div>
    `;
  }

  syncCollectionStateFromContainer(colContainer) {
    if (!colContainer) return null;

    const colId = colContainer.dataset.colId;
    if (!colId) return null;

    const state = this.collectionStates[colId] || { selectedProducts: [], isActive: false };
    const primaryItems = Array.from(colContainer.querySelectorAll(".bundle-col-item:not([data-is-variant-addon='true']):not([data-nr-main-card])"));

    state.selectedProducts = primaryItems.map((item) => ({
      id: item.dataset.productId,
      variantId: item.dataset.variantId,
      price: parseInt(item.dataset.price) || 0,
      compareAtPrice: parseInt(item.dataset.compare) || 0,
      title: item.dataset.productTitle || "",
      image: item.dataset.image || "",
      fullImage: item.dataset.fullImage || item.dataset.image || "",
      url: item.dataset.url || "#",
      variantTitle: item.dataset.variantTitle || "",
      inputTypes: this.normalizeInputTypes(item.dataset.inputTypes),
      canBeAdded: item.dataset.canBeAdded === "true",
    }));
    state.isActive = primaryItems.length > 0;

    this.collectionStates[colId] = state;
    return state;
  }

  attachColItemDelegation(container) {
    if (!container) return;

    // Click delegation
    container.addEventListener("click", (e) => {
      const target = e.target;

      // Qty minus
      const minusBtn = target.closest(".col-qty-minus");
      if (minusBtn) {
        e.preventDefault();
        const input = minusBtn.parentElement.querySelector(".col-qty-input");
        if (input && parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
          this.calculateTotal();
        }
        return;
      }

      // Qty plus
      const plusBtn = target.closest(".col-qty-plus");
      if (plusBtn) {
        e.preventDefault();
        const input = plusBtn.parentElement.querySelector(".col-qty-input");
        if (input) {
          input.value = parseInt(input.value) + 1;
          this.calculateTotal();
        }
        return;
      }

      // Remove button
      const removeBtn = target.closest(".col-item-remove-btn");
      if (removeBtn) {
        const colItem = removeBtn.closest(".bundle-col-item");
        if (colItem) {
          this.removeColItem(colItem);
        }
        return;
      }

      // Add button
      const addBtn = target.closest(".col-item-add-btn");
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        const colItem = addBtn.closest(".bundle-col-item");
        if (colItem) {
          this.handleColItemAddClick(colItem, container);
        }
        return;
      }

      // Variant trigger
      const variantTrigger = target.closest(".bundle-dynamic-variant.bundle-variant-trigger");
      if (variantTrigger) {
        e.stopPropagation();
        const colItem = variantTrigger.closest(".bundle-col-item");
        if (colItem) {
          const isVariantAddon = colItem.dataset.isVariantAddon === "true";
          if (isVariantAddon) {
            const productId = colItem.dataset.productId;
            const colContainer = container.closest(".bundle-col-container");
            if (colContainer) {
              const primaryItem = this.findPrimaryItemByProductId(colContainer, productId);
              if (primaryItem) {
                this.openVariantPopup(primaryItem);
              }
            }
          } else {
            this.openVariantPopup(colItem);
          }
        }
        return;
      }

      // Variants accordion header
      const header = target.closest(".bundle-variants-header");
      if (header) {
        const content = header.nextElementSibling;
        const arrow = header.querySelector(".bundle-variants-arrow");
        const computedDisplay = window.getComputedStyle(content).display;
        if (computedDisplay === "none") {
          content.style.display = "block";
          if (arrow) arrow.textContent = "▲";
        } else {
          content.style.display = "none";
          if (arrow) arrow.textContent = "▼";
        }
        return;
      }
    });

    // Change delegation
    container.addEventListener("change", (e) => {
      const target = e.target;

      // Image input file validation
      if (target.classList.contains("bundle-image-input")) {
        const file = target.files?.[0];
        const errorMsg = target.parentElement.querySelector(".custom-property-error");
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (file) {
          if (file.size > maxSize) {
            target.style.borderColor = "red";
            if (errorMsg) {
              errorMsg.textContent = `File size (${(file.size / 1024 / 1024).toFixed(2)}MB) exceeds 5MB limit`;
              errorMsg.style.display = "block";
            }
            target.value = ""; // Clear selection
          } else {
            target.style.borderColor = "#ccc";
            if (errorMsg) errorMsg.style.display = "none";
          }
        }
        return;
      }

      // Qty input
      if (target.classList.contains("col-qty-input")) {
        if (parseInt(target.value) < 1 || isNaN(parseInt(target.value))) {
          target.value = 1;
        }
        const colItem = target.closest(".bundle-col-item");
        if (colItem) this.syncCustomInputsToQty(colItem);
        this.calculateTotal();
        return;
      }

      // Variant checkbox
      if (target.classList.contains("bundle-variant-checkbox")) {
        this.handleVariantCheckboxChange(target);
        return;
      }
    });
  }

  bindColVariantCheckbox(cb) {
    cb.addEventListener("change", () => {
      this.handleVariantCheckboxChange(cb);
    });
  }

  removeColItem(item) {
    if (!item) return;
    const productId = item.dataset.productId;
    const colContainer = item.closest(".bundle-col-container");
    const productGroup = item.closest(".bundle-col-product-group");

    // Remove the item from DOM
    item.remove();

    // Check if product group is now empty
    if (productGroup) {
      const remainingItems = productGroup.querySelectorAll(".bundle-col-item");
      if (remainingItems.length === 0) {
        productGroup.remove();
        // Deselect the option item (triggers click which updates state)
        if (colContainer) {
          const optionEl = colContainer.querySelector(`.bundle-col-option-item[data-product-id="${productId}"]`);
          if (optionEl) {
            optionEl.click();
            return; // click handler already calls calculateTotal
          }
        }
      }
    }

    // Sync selectedProducts/state from DOM so footer visibility stays correct.
    if (colContainer) {
      this.syncCollectionStateFromContainer(colContainer);
    }

    this.calculateTotal();
  }
  handleVariantCheckboxChange(cb) {
    const colItem = cb.closest(".bundle-col-item");
    const itemsContainer = cb.closest(".col-items-container");
    const colWrapper = cb.closest(".bundle-col-container");
    if (!colItem || !itemsContainer) return;

    const isChecked = cb.checked;
    const canBeAdded = colItem.dataset.canBeAdded === "true";
    const productId = cb.dataset.productId;
    const variantsData = cb.closest(".bundle-variants-data");
    if (!variantsData) return;

    if (!canBeAdded && isChecked) {
      const allVariantCheckboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
      allVariantCheckboxes.forEach((checkbox) => {
        if (checkbox !== cb && checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }

    const allChecked = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox:checked"));

    if (allChecked.length === 0) {
      this.removeColItem(colItem);
    } else {
      this.updateItemFromVariant(colItem, allChecked[0]);

      if (!canBeAdded) {
        const existingVariantAddons = itemsContainer.querySelectorAll(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"]`);
        existingVariantAddons.forEach((addon) => {
          addon.remove();
        });
      } else {
        if (isChecked) {
          const colId = colWrapper.dataset.colId;
          const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
          const masterProd = collection ? collection.products.find((p) => String(p.id) === String(productId)) : null;
          const fakeProd = {
            id: cb.dataset.productId,
            variantId: cb.value,
            price: cb.dataset.price,
            compareAtPrice: cb.dataset.compare,
            title: cb.dataset.title,
            image: cb.dataset.image,
            fullImage: cb.dataset.fullImage,
            url: cb.dataset.url || "#",
            variantTitle: cb.dataset.variantTitle,
            inputType: colItem.dataset.inputType || "",
            inputLabel: colItem.dataset.inputLabel || "",
            isRequired: colItem.dataset.isRequired === "true",
            description: colItem.dataset.description || "",
            placeholder: colItem.dataset.placeholder || "",
            inputTypes: this.normalizeInputTypes(
              cb.dataset.inputTypes || colItem.dataset.inputTypes,
              colItem.dataset.inputType,
              colItem.dataset.inputLabel,
              colItem.dataset.isRequired === "true",
              colItem.dataset.placeholder,
              colItem.dataset.description,
            ),
            variants: masterProd ? masterProd.variants : null,
            canBeAdded: canBeAdded,
          };
          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          const insertTarget = productGroup || colItem.parentElement;
          insertTarget.insertAdjacentHTML("beforeend", this.renderColItemHTML(fakeProd));
          const newAddon = insertTarget.lastElementChild;
          newAddon.dataset.isVariantAddon = "true";
          newAddon.dataset.productId = colItem.dataset.productId;

          const tooltips = newAddon.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });
        } else {
          const addonToRemove = itemsContainer.querySelector(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"][data-variant-id="${cb.value}"]`);
          if (addonToRemove) addonToRemove.remove();
        }
      }

      this.calculateTotal();
    }
  }

  handleColItemAddClick(colItem, itemsContainer) {
    const productId = colItem.dataset.productId;
    const colContainer = itemsContainer.closest(".bundle-col-container");
    if (!colContainer) return;

    const colId = colContainer.dataset.colId;
    const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
    if (!collection || !collection.products) return; // Find the original product (primary item) from the collection
    const masterProd = collection.products.find((p) => String(p.id) === String(productId));
    if (!masterProd) return;

    // Clone product data and apply the current variant from colItem
    const currentVariantId = colItem.dataset.variantId;
    const productData = Object.assign({}, masterProd);

    if (currentVariantId && masterProd.variants && masterProd.variants.length > 1) {
      const matchedVariant = masterProd.variants.find((v) => String(v.id) === String(currentVariantId));
      if (matchedVariant) {
        productData.variantId = matchedVariant.id;
        productData.variantTitle = matchedVariant.title || "";
        productData.price = matchedVariant.price;
        productData.compareAtPrice = matchedVariant.compareAtPrice || 0;
        if (matchedVariant.image) productData.image = matchedVariant.image;
        if (matchedVariant.fullImage) productData.fullImage = matchedVariant.fullImage;
      }
    }

    this.addColItemToContainer(productData, itemsContainer);
  }

  openVariantPopupForAdd(colItem) {
    if (!this.variantPopup) {
      this.initVariantPopup();
    }

    const variantsData = colItem.querySelector(".bundle-variants-data");
    if (!variantsData) {
      return;
    }

    const checkboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
    if (!checkboxes.length) {
      return;
    }

    const grid = this.variantPopup.querySelector(".bundle-variant-popup__grid");
    grid.innerHTML = "";

    checkboxes.forEach((cb) => {
      const vTitle = cb.dataset.variantTitle || cb.dataset.title || "Variant";
      const vPrice = parseFloat(cb.dataset.price) || 0;
      const vImg = cb.dataset.image || "";
      const isDisabled = cb.disabled;

      const cell = document.createElement("div");
      cell.className = "bundle-variant-popup__item" + (isDisabled ? " is-disabled" : "");
      cell.innerHTML = `
        ${vImg ? `<img src="${vImg}" alt="${vTitle}" />` : `<div class="bundle-variant-popup__no-img"></div>`}
        <div class="bundle-variant-popup__item-title">${vTitle}</div>
        <div class="bundle-variant-popup__item-price">$${(vPrice / 100).toFixed(2)}</div>
        <div class="bundle-variant-popup__item-check">✓</div>
      `;

      if (!isDisabled) {
        this.nrBindTap(cell, () => cell, () => {
          if (this._addButtonContext) {
            const { masterProd, itemsContainer } = this._addButtonContext;

            // Create new product data with selected variant
            const newProductData = JSON.parse(JSON.stringify(masterProd));
            newProductData.variantId = cb.value;
            newProductData.variantTitle = cb.dataset.variantTitle || cb.dataset.title || "";
            newProductData.price = parseFloat(cb.dataset.price) || 0;
            newProductData.image = cb.dataset.image || masterProd.image;
            newProductData.fullImage = cb.dataset.fullImage || masterProd.fullImage || newProductData.image;

            // Add the new item
            this.addColItemToContainer(newProductData, itemsContainer);

            // Close popup
            this.closeVariantPopup();
            this._addButtonContext = null;
          }
        });
      }

      grid.appendChild(cell);
    });

    this.variantPopup.style.display = "flex";
  }
  addColItemToContainer(productData, itemsContainer) {
    if (!itemsContainer) return;

    // Ensure we're working with the actual col-items-container
    if (!itemsContainer.classList.contains("col-items-container")) {
      itemsContainer = itemsContainer.closest(".col-items-container") || itemsContainer;
    }

    const newItemHtml = this.renderColItemHTML(productData);
    const productId = productData.id;

    // Find or create the product group wrapper
    let productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
    if (!productGroup) {
      const groupHtml = `<div class="bundle-col-product-group" data-product-id="${productId}"></div>`;
      itemsContainer.insertAdjacentHTML("beforeend", groupHtml);
      productGroup = itemsContainer.lastElementChild;
    }

    productGroup.insertAdjacentHTML("beforeend", newItemHtml);
    const newItem = productGroup.lastElementChild;
    // Attach events only to the new item, not the entire container
    if (newItem) {
      // Setup tooltip positioning for tooltips in new item
      const tooltips = newItem.querySelectorAll(".bundle-tooltip");
      tooltips.forEach((tooltip) => {
        this.attachTooltipPositioningListener(tooltip);
      });
    }

    this.calculateTotal();
  }

  syncCustomInputsToQty(colItem) {
    const inputDefs = this.getTextInputTypes(this.getColItemInputTypes(colItem));
    if (!inputDefs.length) return;

    const qtyInput = colItem.querySelector(".col-qty-input");
    const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

    const inputWrapper = colItem.querySelector(".bundle-item__custom-input");
    if (!inputWrapper) return;

    const oldValues = {};
    const oldInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
    oldInputs.forEach((input) => {
      oldValues[input.dataset.propertyName] = input.value;
    });

    const variantId = colItem.dataset.variantId || colItem.dataset.productId;

    // Re-render all inputs from scratch based on qty
    let html = "";
    for (let i = 0; i < qty; i++) {
      const labelSuffix = qty > 1 ? ` #${i + 1}` : "";
      inputDefs.forEach((inputDef, index) => {
        const inputLabel = inputDef.label || "Customize Your Stole";
        const displayLabel = this.nrEscape(this.nrCustomInputDisplayLabel(inputLabel));
        const isRequired = !!inputDef.required;
        const description = inputDef.description_optional || "";
        const placeholder = inputDef.placeholder || "";
        const propertyName = `${inputLabel}${labelSuffix}`;
        const tooltipHtml = description && description !== "null" ? `<div class="bundle-tooltip">?<div class="bundle-tooltip-text">${description}</div></div>` : "";
        const placeholderText = placeholder && placeholder !== "null" ? placeholder : `Enter ${inputLabel}...`;

        html += `
          <div class="bundle-col-custom-input-row">
            <label class="bundle-custom-input-label" for="col-custom-input-${variantId}-${i}-${index}">
              ${displayLabel}${labelSuffix}${isRequired ? ' <span style="color: red; margin-left: 2px;">*</span>' : ""}:
              ${tooltipHtml}
            </label>
            <input type="text"
              id="col-custom-input-${variantId}-${i}-${index}"
              class="bundle-custom-input custom-property-input col-custom-property-input"
              placeholder="${placeholderText}"
              data-property-name="${propertyName}"
              data-is-required="${isRequired}"
            />
            <div class="custom-property-error">${displayLabel} is required.</div>
          </div>
        `;
      });
    }
    inputWrapper.innerHTML = html;

    const newInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
    newInputs.forEach((input) => {
      const previousValue = oldValues[input.dataset.propertyName];
      if (previousValue !== undefined) {
        input.value = previousValue;
      }
    });
  }

  findPrimaryItemByProductId(container, productId) {
    if (!container || !productId) return null;
    return container.querySelector(`.bundle-col-item[data-product-id="${productId}"]:not([data-is-variant-addon])`);
  }

  initVariantPopup() {
    if (this.variantPopup) {
      return;
    }

    const popup = document.createElement("div");
    popup.className = "bundle-variant-popup-overlay";
    popup.innerHTML = `
      <div class="bundle-variant-popup">
        <div class="bundle-variant-popup__header">
          <span class="bundle-variant-popup__title">Select Variant</span>
          <button type="button" class="bundle-variant-popup__close">&times;</button>
        </div>
        <div class="bundle-variant-popup__grid"></div>
        <div class="bundle-variant-popup__footer">
          <button type="button" class="bundle-variant-popup__ok">OK</button>
        </div>
      </div>
    `;

    popup.querySelector(".bundle-variant-popup__close").addEventListener("click", () => {
      this.closeVariantPopup();
    });
    popup.querySelector(".bundle-variant-popup__ok").addEventListener("click", () => {
      this.closeVariantPopup();
    });
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        this.closeVariantPopup();
      }
    });

    document.body.appendChild(popup);
    this.variantPopup = popup;
  }

  closeVariantPopup() {
    if (this.variantPopup) {
      this.variantPopup.style.display = "none";
    }
    this._popupActiveItem = null;
  }

  openVariantPopup(item) {
    if (!this.variantPopup) {
      this.initVariantPopup();
    }

    const variantsData = item.querySelector(".bundle-variants-data");
    if (!variantsData) {
      return;
    }

    const checkboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
    if (!checkboxes.length) {
      return;
    }

    this._popupActiveItem = item;
    const grid = this.variantPopup.querySelector(".bundle-variant-popup__grid");
    grid.innerHTML = "";

    checkboxes.forEach((cb) => {
      const vTitle = cb.dataset.variantTitle || cb.dataset.title || "Variant";
      const vPrice = parseFloat(cb.dataset.price) || 0;
      const vImg = cb.dataset.image || "";
      const isChecked = cb.checked;
      const isDisabled = cb.disabled;

      const cell = document.createElement("div");
      cell.className = "bundle-variant-popup__item" + (isChecked ? " is-selected" : "") + (isDisabled ? " is-disabled" : "");
      cell.innerHTML = `
        ${vImg ? `<img src="${vImg}" alt="${vTitle}" />` : `<div class="bundle-variant-popup__no-img"></div>`}
        <div class="bundle-variant-popup__item-title">${vTitle}</div>
        <div class="bundle-variant-popup__item-price">$${(vPrice / 100).toFixed(2)}</div>
        <div class="bundle-variant-popup__item-check">✓</div>
      `;

      if (!isDisabled) {
        this.nrBindTap(cell, () => cell, () => {
          const canBeAdded = item.dataset.canBeAdded === "true";

          if (!canBeAdded) {
            checkboxes.forEach((c) => {
              c.checked = false;
            });
            cb.checked = true;
          } else {
            cb.checked = !cb.checked;
          }
          cb.dispatchEvent(new Event("change", { bubbles: true }));

          this.openVariantPopup(item);
        });
      }

      grid.appendChild(cell);
    });

    this.variantPopup.style.display = "flex";
  }
  handleVariantCheckboxChange(cb) {
    const colItem = cb.closest(".bundle-col-item");
    const itemsContainer = cb.closest(".col-items-container");
    const colWrapper = cb.closest(".bundle-col-container");

    if (!colItem || !itemsContainer) {
      return;
    }

    const isChecked = cb.checked;
    const canBeAdded = colItem.dataset.canBeAdded === "true";
    const productId = cb.dataset.productId;
    const variantsData = cb.closest(".bundle-variants-data");

    if (!variantsData) {
      return;
    }

    // If canBeAdded is false, allow only ONE variant to be selected at a time
    if (!canBeAdded && isChecked) {
      const allVariantCheckboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
      allVariantCheckboxes.forEach((checkbox) => {
        if (checkbox !== cb && checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }

    const allChecked = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox:checked"));

    if (allChecked.length === 0) {
      // No variants selected — remove item via shared method
      this.removeColItem(colItem);
    } else {
      this.updateItemFromVariant(colItem, allChecked[0]);

      if (!canBeAdded) {
        const existingVariantAddons = itemsContainer.querySelectorAll(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"]`);
        existingVariantAddons.forEach((addon) => {
          addon.remove();
        });
      } else {
        if (isChecked) {
          const colId = colWrapper.dataset.colId;
          const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
          const masterProd = collection ? collection.products.find((p) => String(p.id) === String(productId)) : null;

          const fakeProd = {
            id: cb.dataset.productId,
            variantId: cb.value,
            price: cb.dataset.price,
            compareAtPrice: cb.dataset.compare,
            title: cb.dataset.title,
            image: cb.dataset.image,
            fullImage: cb.dataset.fullImage,
            url: cb.dataset.url || "#",
            variantTitle: cb.dataset.variantTitle,
            inputType: colItem.dataset.inputType || "",
            inputLabel: colItem.dataset.inputLabel || "",
            isRequired: colItem.dataset.isRequired === "true",
            description: colItem.dataset.description || "",
            placeholder: colItem.dataset.placeholder || "",
            variants: masterProd ? masterProd.variants : null,
            canBeAdded: canBeAdded,
          };

          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          const insertTarget = productGroup || colItem.parentElement;

          const newItemHtml = this.renderColItemHTML(fakeProd);

          insertTarget.insertAdjacentHTML("beforeend", newItemHtml);

          const newAddon = insertTarget.lastElementChild;

          newAddon.dataset.isVariantAddon = "true";
          newAddon.dataset.productId = colItem.dataset.productId;

          // Setup tooltip positioning for new addon
          const tooltips = newAddon.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });

          // Attach direct listeners to checkboxes of new addon
          const newCheckboxes = newAddon.querySelectorAll(".bundle-variant-checkbox");
          newCheckboxes.forEach((checkbox) => {
            this.bindColVariantCheckbox(checkbox);
          });
        } else {
          const addonToRemove = itemsContainer.querySelector(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"][data-variant-id="${cb.value}"]`);
          if (addonToRemove) {
            addonToRemove.remove();
          }
        }
      }

      this.calculateTotal();
    }
  }
}

const existingBundleController = customElements.get('products-bundle-custom');
if (!existingBundleController) {
  customElements.define('products-bundle-custom', ProductsBundleCustom);
} else if (existingBundleController !== ProductsBundleCustom) {
  // An older asset may have registered the same element first. Update its methods
  // instead of silently skipping the new controller or defining the element twice.
  for (const name of Object.getOwnPropertyNames(ProductsBundleCustom.prototype)) {
    if (name !== 'constructor') Object.defineProperty(existingBundleController.prototype, name,
      Object.getOwnPropertyDescriptor(ProductsBundleCustom.prototype, name));
  }
  document.querySelectorAll('products-bundle-custom').forEach(element => {
    if (!element.isConnected) return;
    element.disconnectedCallback();
    element.connectedCallback();
  });
}

})();
